import { defineMessages } from '@transcend-io/internationalization';

export const modalMessages = defineMessages('core-ui.Modal.modal', {
  closeLabel: {
    defaultMessage: 'Close',
  },
});
